/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.terms'},
});

const TermsItem = () => (
  <RouteLinkItem route="midas/settings/calendar/terms" title={messages.title} />
);

export default TermsItem;
